var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewsMedia = function SvgNewsMedia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 28.477V6.094c0-.695.3-1.357.824-1.815a12.058 12.058 0 0 1 7.392-2.97l5.354-.244A1.368 1.368 0 0 1 32 2.432V24.86c0 .62-.52 1.113-1.139 1.08l-2.785-.146a14.432 14.432 0 0 0-9.898 3.242.722.722 0 0 1-1.178-.559Z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 28.477V6.094c0-.695-.3-1.357-.824-1.815a12.058 12.058 0 0 0-7.392-2.97L1.43 1.064A1.368 1.368 0 0 0 0 2.432V24.86c0 .62.52 1.113 1.139 1.08l2.785-.146a14.432 14.432 0 0 1 9.898 3.242.722.722 0 0 0 1.178-.559Z"
  })));
};
export default SvgNewsMedia;